
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import TagSelector from '../TagSelector/TagSelector';
import TagModal from '../Tags/TagModal';

const ManageTagsModal = ({ show, onHide, selectedIds, type, onSuccess }) => {
    const [selectedTags, setSelectedTags] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showTagModal, setShowTagModal] = useState(false);
    const tagSelectorRef = React.useRef();

    const handleAction = async (action) => {
        if (!selectedTags || selectedTags.length === 0) {
            toast.error("Please select tags first");
            return;
        }
        if (!selectedIds || selectedIds.length === 0) {
            toast.error("No items selected");
            return;
        }

        setLoading(true);
        try {
            const endpoint = action === 'add' ? 'bulk-assign' : 'bulk-remove';
            const payload = {
                tag_ids: selectedTags.map(t => t.value),
                taggable_ids: selectedIds,
                taggable_type: type // 'License' or 'TrialLicense'
            };

            const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/tags/${endpoint}`, payload, {
                headers: { 'access-token': localStorage.getItem('accessToken') }
            });

            if (response.data.status) {
                toast.success(response.data.message);
                onSuccess();
                onHide();
                setSelectedTags([]);
            } else {
                toast.error(response.data.message || "Operation failed");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Operation failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Manage Tags ({selectedIds?.length} selected)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Select Tags</Form.Label>
                        <TagSelector
                            ref={tagSelectorRef}
                            value={selectedTags}
                            onChange={setSelectedTags}
                            placeholder="Search and select tags..."
                            onCreateTag={() => setShowTagModal(true)}
                        />
                    </Form.Group>
                    <div className="d-flex justify-content-between mt-4">
                        <Button
                            variant="outline-danger"
                            onClick={() => handleAction('remove')}
                            disabled={loading}
                        >
                            {loading ? 'Processing...' : 'Remove Selected Tags'}
                        </Button>
                        <Button
                            className="admin-btn"
                            onClick={() => handleAction('add')}
                            disabled={loading}
                        >
                            {loading ? 'Processing...' : 'Add Selected Tags'}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <TagModal
                show={showTagModal}
                onHide={() => setShowTagModal(false)}
                onSuccess={() => {
                    if (tagSelectorRef.current) {
                        tagSelectorRef.current.refresh();
                    }
                }}
            />
        </>
    );
};

export default ManageTagsModal;
